/*
 * @Author: error: git config user.name & please set dead value or install git
 * @LastEditors: wanglibo
 * @Description: 
 */
import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';

export const htmlToPDF = async (htmlId, bgColor = '#fff') => {
	let pdfDom = document.getElementById(htmlId);
	pdfDom.style.padding = '0 10px !important';
	// const A4Width = 595.28;
	// const A4Height = 841.89;
	let canvas = await html2canvas(pdfDom, {
		scale: 4,
		useCORS: true,
		backgroundColor: bgColor
	});
	// let pageHeight = canvas.width / A4Width * A4Height;
	// let leftHeight = canvas.height;
	// let position = 0;
	// let imgWidth = A4Width;
	// let imgHeight = A4Width / canvas.width * canvas.height;
	/*
     根据自身业务需求  是否在此处键入下方水印代码
    */
	let base64Data = canvas.toDataURL('image/jpeg', 0.8);
	return base64Data
	// console.log("pageData",pageData);
	// const base64String = base64Data.split(',')[1]; // 去掉 data:image/jpeg;base64, 前缀
	// const byteCharacters = atob(base64String);
	// const byteNumbers = new Array(byteCharacters.length);
	// for (let i = 0; i < byteCharacters.length; i++) {
	// 	byteNumbers[i] = byteCharacters.charCodeAt(i);
	// }
	// const byteArray = new Uint8Array(byteNumbers);
	// const blob = new Blob([ byteArray ], { type: 'image/jpeg' });
	// console.log("blob",blob)
	// return blob
	// 创建一个临时的 a 标签来触发下载
	// const link = document.createElement('a');
	// link.href = URL.createObjectURL(blob);
	// link.download = `${title}.jpg`; // 设置下载的文件名
	// document.body.appendChild(link);
	// link.click();
	// document.body.removeChild(link); // 清理

	// let PDF = new jsPDF("p", 'pt', 'a4');
	// PDF.save(title + ".pdf");
	// if (leftHeight < pageHeight) {
	//     PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
	// } else {
	//     while (leftHeight > 0) {
	//         PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
	//         leftHeight -= pageHeight;
	//         position -= A4Height;
	//         if (leftHeight > 0) PDF.addPage();
	//     }
	// }
	// PDF.save(title + ".pdf");
};
